import React from "react";
import { LinearProgress, Typography } from "@mui/material";

const LinearProgressBar = ({ progress, total, color }: any) => {
  const percentage = (progress / total) * 100;
  const percentageOn85Scale = total===0 ? 85 :(percentage * 85) / 100;
  return (
    <div className="linear-progress-container">
      <LinearProgress
        variant="determinate"
        value={percentage}
        sx={{
          width: "85%",
          height: "45px",
          borderRadius: "0 5px 5px 0",
          backgroundColor:'transparent',
          '& .MuiLinearProgress-bar1Determinate': {
              backgroundColor: `${color}`,
            },
        }}
      />
      <Typography
        variant="body2"
        sx={{
          position: "absolute",
          marginTop: "-40px",
          marginLeft: `calc(${percentageOn85Scale}% + 8px)`,
          fontSize: "24px",
          fontWeight: "bold",
        }}
      >
        {progress}
      </Typography>
    </div>
  );
};

export default LinearProgressBar;

